import { Map, Record } from 'immutable';

import { Reducer } from '../../interfaces/State';
import * as actions from '../actions';
import { REQUEST_STATUS, RequestStatus } from '../selectors';

export type IPreFetchedRequest = {
  data: null | unknown;
  status: RequestStatus;
};

export const PreFetchedRequestRecord = Record<IPreFetchedRequest>(
  {
    status: REQUEST_STATUS.NOT_FETCHED,
    data: null,
  },
  'PreFetchedRequestRecord',
);

type PreFetchedDataStateShape = {
  chapter: Record.Instance<IPreFetchedRequest>;
  course: Record.Instance<IPreFetchedRequest>;
  courseImages: Record.Instance<IPreFetchedRequest>;
  exercises: Record.Instance<IPreFetchedRequest>;
  learnRecap: Record.Instance<IPreFetchedRequest>;
  sharedImage: Record.Instance<IPreFetchedRequest>;
  workspaceTemplate: Record.Instance<IPreFetchedRequest>;
};

export type PrefetchedData = Partial<
  {
    [key in keyof PreFetchedDataStateShape]: IPreFetchedRequest;
  }
>;

export const PreFetchedDataStateRecord = Record<PreFetchedDataStateShape>(
  {
    chapter: new PreFetchedRequestRecord({}),
    course: new PreFetchedRequestRecord({}),
    exercises: new PreFetchedRequestRecord({}),
    learnRecap: new PreFetchedRequestRecord({}),
    sharedImage: new PreFetchedRequestRecord({}),
    workspaceTemplate: new PreFetchedRequestRecord({}),
    courseImages: new PreFetchedRequestRecord({}),
  },
  'PreFetchedDataStateRecord',
);
export type PreFetchedDataState = Record.Instance<PreFetchedDataStateShape>;

const initialState = new PreFetchedDataStateRecord({});

const preFetchedDataReducer: Reducer<PreFetchedDataState> = (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case actions.BOOT_SUCCEEDED:
    case actions.BOOT_FAILED:
      return state.merge(
        Map(action.preFetchedData)
          .filter((_value, key: string) => state.has(key))
          .map(
            (preFetchedRequest) =>
              new PreFetchedRequestRecord(preFetchedRequest),
          ),
      );
    default:
      return state;
  }
};

export default preFetchedDataReducer;
